module.exports = __webpack_public_path__ + "static/img/image020.f8a1920.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image020.png
// module id = R4xK
// module chunks = 1